import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  "relative inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm leading-4 transition-all disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-red-500/20 dark:aria-invalid:ring-red-500/40 aria-invalid:border-red-500 [&>svg]:[stroke-width:1.5]",
  {
    variants: {
      variant: {
        primary:
          'bg-teal-600 text-white hover:bg-teal-500 border-2 border-transparent hover:border-teal-400 disabled:bg-teal-100',
        secondary: 'bg-denim-500 text-white hover:bg-denim-400 disabled:bg-denim-100',
        terciary:
          'bg-white text-denim-500 border border-gray-300 hover:bg-teal-100 hover:border-teal-300 disabled:border-gray-100 disabled:text-gray-300',
        destructive:
          'bg-red-600 text-white hover:bg-red-500 border-2 border-transparent hover:border-red-400 disabled:bg-red-100',
        destructive_terciary:
          'bg-white text-red-400 border border-red-200 hover:text-red-500 hover:bg-red-100 hover:border-red-200 disabled:text-red-200 disabled:border-red-100',
        primary_terciary:
          'bg-white text-teal-600 border border-teal-200 hover:text-teal-500 hover:bg-teal-100 hover:border-teal-200 disabled:text-teal-200 disabled:border-teal-100',
        link: 'p-0 h-fit text-gray-500 hover:text-gray-700',
        ghost: 'p-0 h-fit hover:bg-gray-200',
      },
      size: {
        md: 'h-8 px-6 py-2 rounded-2xl font-medium',
        lg: 'h-10 px-6 py-2 rounded-[20px] font-semibold',
        xl: 'h-12 px-8 py-2 rounded-full font-semibold',
      },
      icon: {
        back: 'has-[>svg]:pr-4 has-[>svg]:pl-1.5 gap-4 w-full justify-start',
        trailing: 'has-[>svg]:pl-4 has-[>svg]:pr-1.5 gap-4 justify-between w-full',
        leading: 'has-[>svg]:pr-5 has-[>svg]:pl-4 gap-2',
        only: 'p-0 rounded-full',
      },
      isLoading: {
        true: 'justify-center items-center pointer-events-none',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
    compoundVariants: [
      {
        variant: 'primary',
        class: 'shadow-box-lg disabled:shadow-none',
      },
      {
        variant: 'secondary',
        icon: 'only',
        class: 'disabled:bg-plum-100',
      },
      {
        variant: 'terciary',
        class: 'shadow-box-xs font-medium',
      },
      {
        variant: 'terciary',
        size: 'md',
        class: 'text-xs',
      },
      {
        variant: 'destructive',
        class: ' font-semibold shadow-box-lg disabled:shadow-none',
      },
      {
        variant: 'destructive_terciary',
        class: 'font-medium shadow-box-xs',
      },
      {
        variant: 'destructive_terciary',
        size: 'md',
        class: 'text-xs',
      },
      {
        variant: 'primary_terciary',
        class: 'font-medium shadow-box-xs',
      },
      {
        variant: 'primary_terciary',
        size: 'md',
        class: 'text-xs',
      },
      {
        icon: 'back',
        size: 'lg',
        class: 'has-[>svg]:pr-5 has-[>svg]:pl-2 gap-5',
      },
      {
        icon: 'trailing',
        size: 'lg',
        class: 'has-[>svg]:pr-2 has-[>svg]:pl-5 gap-5',
      },
      {
        icon: 'leading',
        size: 'lg',
        class: 'has-[>svg]:pr-5 has-[>svg]:pl-4 gap-3',
      },
      {
        icon: 'back',
        size: 'xl',
        class: 'has-[>svg]:pr-6 has-[>svg]:pl-2.5 gap-6',
      },
      {
        icon: 'trailing',
        size: 'xl',
        class: 'has-[>svg]:pr-2.5 has-[>svg]:pl-6 gap-6',
      },
      {
        icon: 'leading',
        size: 'xl',
        class: 'has-[>svg]:pr-5 has-[>svg]:pl-4 gap-3',
      },
      {
        icon: 'only',
        size: 'md',
        class: 'min-w-8 min-h-8',
      },
      {
        icon: 'only',
        size: 'lg',
        class: 'min-w-10 min-h-10',
      },
      {
        icon: 'only',
        size: 'xl',
        class: 'min-w-12 min-h-12',
      },
    ],
  }
);
